import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DrawerLayout from '../../components/shared/DrawerLayout';
import UsersDrawerBody from './UsersDrawerBody';
import {
  closeUsersDrawerAndSetQueries,
  selectViewMode,
} from '../../redux/store/ui/common';
import { selectViewType } from '../../redux/store/ui/common/selectors';
import { selectSelectedUser } from '../../redux/store/userData/users';
import { ViewMode } from '../../hooks/viewMode';
import { ViewType } from '../../hooks/useViewType';
import UserDuplicateDrawer from './UserDuplicateDrawer';
import NestedDrawer from '../shared/NestedDrawer';

const UsersDrawer: React.FC = () => {
  const dispatch = useDispatch();
  const selectedUser = useSelector(selectSelectedUser);
  const visible = !!selectedUser && Object.keys(selectedUser).length > 0;
  const viewMode = useSelector(selectViewMode);
  const viewType = useSelector(selectViewType);

  const handleOnClose = () => {
    dispatch(closeUsersDrawerAndSetQueries());
  };

  return (
    selectedUser && (
      <DrawerLayout
        visible={visible}
        title={selectedUser?.id!!}
        body={<UsersDrawerBody selectedUser={selectedUser} />}
        nestedDrawers={
          <>
            {viewMode !== ViewMode.RECEIPTS && <NestedDrawer name="receipt" />}
            {/* In the Timetable view TripDrawer already nests UsersDrawer; nesting
                TripDrawer back here makes the two drawers re-render each other
                infinitely (Maximum update depth) when a trip + user are both open. */}
            {viewMode !== ViewMode.SHARE &&
              !(
                viewMode === ViewMode.VEHICLE &&
                viewType === ViewType.TIME_TABLE
              ) && <NestedDrawer name="trip" />}
            <UserDuplicateDrawer />
          </>
        }
        onReload={undefined}
        onClose={handleOnClose}
      />
    )
  );
};

export default UsersDrawer;
